import { Component, OnInit, OnDestroy, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as UserActions from '@ibe/store/actions/user.actions';
import { Router } from '@angular/router';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.css'],
	host: {
		class: 'app-confirm-dialog'
	}
})
export class INDRAConfirmDialogComponent extends ConfirmDialogComponent
	implements OnInit, OnDestroy {
	@HostBinding('class.is-open')
	isOpen: boolean;
	isAlive = true;
	htmlElement = document.getElementsByTagName('html');

	@Input() ariaLabel = null;
	@Input() overlay: boolean = false;
	@Input() lockScroll: boolean = false;

	@Input() isLoading: boolean = false;
	@Output() onClose = new EventEmitter();

	constructor(
		private store: Store<fromStore.State>,
		private router: Router,
		private _ConfirmDialogService: ConfirmDialogService) {
		super();
	}

	ngOnInit() {
		this._ConfirmDialogService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					this.isOpen = value;
					if (this.lockScroll) {
						if (this.isOpen) {
							this.htmlElement[0].classList.add('no-scroll');
						} else {
							this.htmlElement[0].classList.remove('no-scroll');
						}
					}
				},
				error => console.error(error),
				() => { }
			);
		if (this.isOpen === true) {
			if (this.router.url.indexOf('/flights') > 0)
				this.store.dispatch(new UserActions.PutConfirmDialogAction(true));
		}

	}

	ngOnDestroy() {
		this.isAlive = false;
		this.store.dispatch(new UserActions.PutConfirmDialogAction(false));
		if (this.lockScroll) {
			this.htmlElement[0].classList.remove('no-scroll');
		}
	}

	closeDialog() {
		this.onClose.emit();
		this._ConfirmDialogService.closeConfirmDialog();
		if (this.lockScroll) {
			this.htmlElement[0].classList.remove('no-scroll');
		}
	}
}
